export const CustomersResponse = (
  api_result,
  setCustomersType,
  setCustomerTypeListItem,
  setCustomers
) => {
  let result_data = api_result?.data
  let customer_types = result_data?.customer_types
  let customers = result_data?.['customers']
  let obj = {}
  for (let type of customer_types) {
    obj[type?.id] = customers.filter(
      (customer) => parseInt(customer?.['customer_type_id']) === type?.id
    )
  }
  setCustomersType(customer_types)
  setCustomerTypeListItem(obj)
  setCustomers(customers)
}

export const LazyCustomersResponse = (customers, customer_types, setCustomerTypeListItem) => {
  let obj = {}
  for (let type of customer_types) {
    obj[type?.id] = customers.filter(
      (customer) => parseInt(customer?.['customer_type_id']) === type?.id
    )
  }
  setCustomerTypeListItem(obj)
}

export const EditCustomersResponse = (
  customer,
  customers,
  customer_types,
  setCustomerTypeListItem,
  setCustomers,
  setShowModal
) => {
  let customersIndex = customers?.findIndex((elem) => elem.id === parseInt(customer?.id))

  if (customersIndex >= 0) {
    customers[customersIndex] = customer
    let obj = {}
    for (let type of customer_types) {
      obj[type?.id] = customers.filter(
        (customer) => parseInt(customer?.['customer_type_id']) === type?.id
      )
    }
    setCustomerTypeListItem(obj)
    setCustomers(customers)
    setShowModal(false)
  }
}
